import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import NotificationsIcon from '@mui/icons-material/Notifications';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import MenuIcon from '@mui/icons-material/Menu';
import { Badge, Grid } from '@mui/material';
import { options } from '@config';
import { gold, white } from '../../../../getLPTheme';
import { useAppDispatch, useAppSelector } from '../../../../hooks';
import { increment, decrement, incrementByAmount, decreemenByAmount, reset  } from '../../counterSlice';


export default function IconNotifications() {

    // const dispatch = useAppDispatch()
    // const notifications = items.notifications

    // const [count, setCount] = React.useState(0)

    // let contadorAux = 0

    // for (let i = 0; i < notifications.length; i++) {
    // if (notifications[i].status === 'unread') 
    //     contadorAux++;
    // }


    let counterNotifications = useAppSelector(state => state.counter.value)

    // React.useEffect(() => {
    //     setCount(contadorAux)
    //   }, [])
    

    return (
        <IconButton color="secondary">
            <Badge badgeContent={counterNotifications} sx={{color: white[50]}}>
                <NotificationsIcon sx={{color: gold[400]}}/>
            </Badge>
        </IconButton>
    )
}

